import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { AccordionSimple } from "../../../../accordion/src";
import { Box } from "../../../../box/src";
import { Card } from "../../../../card/src";
export const Container = forwardRef(({ TitleComponent, children, dndSortableProps, id, isOpen: initialIsOpen = true, label, }, ref) => {
    const [isOpen, setIsOpen] = useState(initialIsOpen);
    const onToggle = () => {
        setIsOpen((prev) => !prev);
    };
    const AccordionTitle = (_jsx(TitleComponent, { data: { id, label }, dndSortableProps: dndSortableProps, isOpen: isOpen }));
    return (_jsx(Card, { "data-testid": `card-draggable-list-${id}`, height: "100%", mb: 5, mt: 0, p: 0, ref: ref, children: _jsx(AccordionSimple, { isOpen: isOpen, onToggle: onToggle, title: AccordionTitle, children: ({ ref }) => _jsx(Box, { ref: ref, children: children }) }) }));
});
//# sourceMappingURL=Container.js.map